module.exports = __webpack_public_path__ + "img/1.6b8d58f6.png";